import { makeAutoObservable } from 'mobx';
import { DEFAULT_PAGE_SIZE } from '../config/config';
import CupomService from '../services/CupomService';
import { PaginationParams } from '../types';
import { message } from 'antd';
import { removeSpecialCharacters } from '../utils/functions';


class CupomStore {
    loading: boolean = false;
    cupomList: any = [];
    cupomProps: any;
    zipCodeRestriction: any;
    categoriesOrProdutcts: any;
    zipCodeRestrictionList: any = [];
    dateRestrictionList: any = [];
    categoryList: any = [];
    channelOrSubChannel: any;
    customerRestrictionItem: any = [];
    productList: any = [];
    customerList: any = [];
    sort?: string = '';
    reportsCupom?: any;
    totalPages: number = 0;
    page: number = 0;
    totalElements: number = 0;
    size: number = DEFAULT_PAGE_SIZE;
    defaultparams = {
        size: DEFAULT_PAGE_SIZE,
        page: 0,
        sort: 'created,desc',
        search: '',
    }

    constructor() {
        makeAutoObservable(this);
    }

    reset() {
        this.cupomProps = undefined;
        this.zipCodeRestrictionList = [];
        this.dateRestrictionList = [];
        this.zipCodeRestriction = undefined;
    }

    async getList(params: PaginationParams) {
        this.loading = true;
        const response = await CupomService.getList(params);

        if (!response.error) {
            this.cupomList = response.data.content;
            this.totalPages = response.data.totalPages;
            this.page = response.data.number;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
            this.sort = params.sort;
        }
        this.loading = false;

        return response;
    }


    async deleteCupom(uuid: string) {
        this.loading = true;
        const response = await CupomService.deleteCupom(uuid);

        if (response.error) {
            message.error(`Erro ao deletar Cupom`);
        } else {
            message.success('Cupom deletado com sucesso!');
        }

        this.cupomProps = response.data;
        this.loading = false;
        return response;
    }


    async deleteCupomAll(uuid: string) {
        this.loading = true;
        const response = await CupomService.deleteCupom(uuid);
        this.cupomProps = response.data;
        this.loading = false;
        return response;
    }

    async createCupom(data: any) {
        this.loading = true;
        const response = await CupomService.createCupom(data);

        if (response.error) {
            this.cupomProps = data;
            message.error(`Erro ao criar Cupom`);
        } else {
            message.success('Cupom cadastrada com sucesso!');
        }

        this.loading = false;
        return response;
    }

    async editCupom(data: any, uuid: string | undefined) {
        this.loading = true;

        const response = await CupomService.editCupom(data, uuid);

        if (response.error) {
            message.error(`Erro ao editar Cupom`);
        } else {
            message.success('Cupom editada com sucesso!');
        }

        this.loading = false;
        return response;
    }


    //Cadastro e Edição de Cupom
    async getCupomByUuid(uuid: string) {
        this.loading = true;
        const response = await CupomService.getCupomByUuid(uuid);

        if (response.error) {
            message.error(`Erro ao buscar Cupom`);
            return;
        }

        const zipCodeRestriction = response?.data?.restrictions.find((restriction: any) =>
            restriction["@class"] === "br.com.stoom.kernel.model.persistence.restriction.ZipCodeRestriction"
        );

        const dateRestriction = response?.data?.restrictions.find((restriction: any) =>
            restriction["@class"] === "br.com.stoom.kernel.model.persistence.restriction.DateRestriction"
        );

        const categoryRestriction = response?.data?.restrictions.find((restriction: any) =>
            restriction["@class"] === "br.com.stoom.kernel.model.persistence.restriction.ProductCategoryRestriction"
        );

        const productRestriction = response?.data?.restrictions.find((restriction: any) =>
            restriction["@class"] === "br.com.stoom.kernel.model.persistence.restriction.ProductCategoryRestriction"
        );

        const customerRestricion = response?.data?.restrictions.find((restriction: any) =>
            restriction["@class"] === "br.com.stoom.kernel.model.persistence.restriction.CustomerRestriction"
        );

        const uuids = categoryRestriction?.categories?.map((category: any) => category.uuid);
        this.customerRestrictionItem = customerRestricion;
        this.customerList = customerRestricion?.documents
        this.categoryList = uuids;
        this.productList = productRestriction?.products;
        this.zipCodeRestriction = zipCodeRestriction;
        this.categoriesOrProdutcts = categoryRestriction
        this.zipCodeRestrictionList = zipCodeRestriction?.zipCodeRangeRestrictions;
        this.dateRestrictionList = dateRestriction;
        this.cupomProps = response.data;
        this.loading = false;
        return response.data;
    }


    async updateZipCodeList(data: any) {
        if (!this.zipCodeRestrictionList) {
            this.zipCodeRestrictionList = [];
        }

        this.zipCodeRestrictionList.push(data);
    }

    async removeZipCode(uuid: string) {
        const filterZipCode = this.zipCodeRestrictionList.filter((item: any) => item.uuid !== uuid);
        this.zipCodeRestrictionList = filterZipCode
    }

    async updateCategory(data: any) {
        if (!this.categoryList) {
            this.categoryList = [];
        }

        this.categoryList = data.checked;
    }

    async updateProduct(data: any) {
        const product = {
            active: true,
            name: data?.name,
            skuCode: data?.skuCode,
            uuid: data?.uuid
        }

        if (!this.productList) {
            this.productList = [];
        }

        const findProduct = this.productList.find((item: any) => item.uuid === product.uuid);
        const isProductFound = !!findProduct;

        if (isProductFound) {
            message.error(`Produto já adicionado`);
        } else {
            this.productList.push(product);
        }
    }


    async updateCustomer(data: any) {
        if (!this.customerList) {
            this.customerList = [];
        }

        const findCustomer = this.customerList.find((item: any) => item === removeSpecialCharacters(data.document));
        const isCustomerFound = !!findCustomer;

        if (isCustomerFound) {
            message.error(`Cliente já adicionado`);
        } else {
            this.customerList.push(data.document);
        }
    }

    async removeCustomer(uuidCustomer: any) {
        const filterProduct = this.customerList.filter((item: any) => item !== uuidCustomer);
        this.customerList = filterProduct
    }

    async removeProdut(uuidProduct: string) {
        const filterProduct = this.productList.filter((item: any) => item.uuid !== uuidProduct);
        this.productList = filterProduct
    }


    // Reports
    async getReports(params: any) {
        this.loading = true;
        const response = await CupomService.getReports(params);
        this.reportsCupom = response.data;
        this.loading = false;
        return response;
    }

    async updateValue(type: string) {
        const newCampaignProps = { ...this.cupomProps, type: type };
        this.cupomProps = newCampaignProps;
    }
}

const cupomStore = new CupomStore();
export default cupomStore;